import aHttp from '@/models/axiosConfig/aHttp';
import constants from '@/constants';
const {
  API_LIST: {
    EMTCSLP_EXTERNAL_APIGATEWAY_PROD,
    EMTCSLP_EXTERNAL_APIGATEWAY_GAMMA
  }
} = constants;

const urls = {
  categoriesList: `${EMTCSLP_EXTERNAL_APIGATEWAY_GAMMA}/config/category`
};
export const categoriesList = params => aHttp.get(urls.categoriesList, params);
